//#region src/secret_menu_type.ts
let SecretMenuType = /* @__PURE__ */ function(SecretMenuType) {
	SecretMenuType["SideNav"] = "side-nav";
	return SecretMenuType;
}({});
//#endregion
export { SecretMenuType };

//# sourceMappingURL=secret_menu_type.js.map